import React, { useState } from 'react';
import { observer } from 'mobx-react';
import stores from '../../../models/Stores';
import './projectTitle.scss';
import { formatDate } from 'cd-eft/utils/formatDate';

import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import { DelineateWatershedInputStateVM } from 'cd-eft/components/EFH2/DelineateWatershedInput/DelineateWatershedInputStateVM';

const libraryStore = stores.AppStore.projectsLibraryStore;
interface IProjectTitleProps {
  currentStep?: number,
  demName?: string,
  watershedAcreage?: number
}

const ProjectTitleComponent = (props: IProjectTitleProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentProject = stores.AppStore.efh2Store.projectsStore.currentProject;
  const toggle = () => setIsOpen(!isOpen);

  function formatStateCounty() {
    if (currentProject.county && currentProject.state) {
      return `${currentProject.county}, ${currentProject.state}`;
    }
    else if (currentProject.county) {
      return currentProject.county;
    }
    else if (currentProject.state) {
      return currentProject.state;
    }
    else {
      return 'Unavailable'
    }
  }

  function formatAcreage() {
    if (props.watershedAcreage && props.watershedAcreage > 0) {
      const result = props.watershedAcreage.toFixed(2);
      if (props.watershedAcreage === 1) {
        return result + ' acre';
      }
      else {
        return result + ' acres'
      }
    }
    else return 'Unavailable'
  }

  return (
    <div hidden={!currentProject.projectUuid}>
      <div
        className={`${props.currentStep === 4
          ? 'project-panel-container project-panel-container1'
          : 'project-panel-container'
          }`}
      >
        <div
          className="project-form-panel"
          style={{ lineHeight: 1.2 }}
        >
          <CollapseMenu
            title={`Project Details`}
            cardBodyId={`projectTitle`}
            noIcon={true}
            forceOpen={false}
            className="m-0"
          >
            <div>
              <strong>Project Name: </strong>
              {currentProject.projectTitle}
            </div>
            <div className="capitalize">
              <strong>Project Owner: </strong>
              {currentProject.projectOwnerEmail ? currentProject.projectOwnerEmail.split('@')[0].replace('.', ' ') : ''}
            </div>
            <div>
              <strong>Created On:</strong> {formatDate(currentProject.createdDate)}
            </div>
            <div>
              <strong>Last Updated By: </strong>
              {currentProject.lastChangedBy}
            </div>
            <div>
              <strong>Last Updated On: </strong>
              {formatDate(currentProject.lastChangedDate)}
            </div>
            <div>
              <strong>Project Type: </strong>
              {currentProject.projectClassType}
            </div>
            <div data-testid="project-location">
              <strong>Location: </strong>
              {formatStateCounty()}
            </div>
            <div data-testid="dem-name">
              <strong>DEM Service Selected: </strong>
              {props.demName ? props.demName : 'Unavailable'}
            </div>
            <div data-testid="watershed-acres">
              <strong>Watershed Acreage: </strong>
              {formatAcreage()}
            </div>
            <div data-testid="projection-information">
              <strong>Projection Information: </strong>
              {libraryStore.projectProjectionInfo}
            </div>
          </CollapseMenu>
        </div>
      </div>
    </div>
  );
};

export const ProjectTitle = observer(ProjectTitleComponent);
